import type { SelectOption } from "@/components/Form/Form.types";

const paymentFrequencies = ["weekly", "fortnightly", "monthly", "quarterly", "annually"] as const;

const paygTypes = [
    "Permanent Employee",
    "Permanent Employee (Medical & Emergency Services)",
    "Director's Wages",
    "Casual / Contractor / Gig Economy",
    "Uncertain (Commission, Overtime)",
    "Uncertain (Bonus)",
] as const;

const employmentTypes = [...paygTypes, "Contractor"] as const;

export { paymentFrequencies, paygTypes, employmentTypes };

// dropdowns values
const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const frequencyOptions: SelectOption[] = paymentFrequencies.map((freq) => ({
    value: freq,
    label: capitalize(freq),
}));

export const paygTypeOptions: SelectOption[] = paygTypes.map((type) => ({
    value: type,
    label: type,
}));

export const employmentTypeOptions: SelectOption[] = employmentTypes.map((type) => ({
    value: type,
    label: type,
}));
